import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { cssClass } from '../../../../common/styles/CommonStyles';
import { generateUniqueId } from '../../../../common/utils/DomUtils';
import { imgPath } from '../../../../common/utils/ImgUrl';

export const CollectionsPrivateIndicatorIdPrefix = 'collections-private-indicator';

const PrivateCollectionAreaListView = cssClass('collections-private-indicator', {
  paddingLeft: TabStyles.Spacing.DefaultSpace,
  fontSize: '12px',
  fontWeight: 'normal',
});

const LOCKED_IMG = imgPath('lock_locked_14px-small.svg');
export const CollectionPrivateHeader = 'collection-private-header';

export function CollectionsPrivateIndicator() {
  const privateIndicatorId = generateUniqueId(CollectionsPrivateIndicatorIdPrefix);
  return (
    <span className={PrivateCollectionAreaListView} id={privateIndicatorId}>
      <div data-tb-test-id={CollectionPrivateHeader}>
        <img src={LOCKED_IMG} alt="" />
        <span style={{ marginLeft: 2 }}>{Messages.collectionVisibilityPrivateCellLabel()}</span>
      </div>
    </span>
  );
}
